// Pages render MerchantNav as `fixed` and pad their content for the nav alone,
// so the impersonation banner needs a known height that App.vue can offset
// with a matching spacer.
export const IMPERSONATION_BANNER_HEIGHT_CLASS = 'h-10'
